const getCodeValue = () => {
  if (typeof window === 'undefined') return '';
  const params = new URLSearchParams(window.location.search);
  const value = params.get('code');
  if (!value || !/^\d{6}$/.test(value)) return;
  return value;
};

const getVibrateValue = () => {
  if (typeof window === 'undefined') return false;
  if ('vibrate' in navigator) {
    const vibrate = localStorage.getItem('rfs:vibrate');
    if (!['true', 'false'].includes(vibrate)) {
      localStorage.setItem('rfs:vibrate', true);
      return true;
    }
    return vibrate === 'true';
  }
  localStorage.removeItem('rfs:vibrate');
  return null;
};

const getWakeLockValue = () => {
  if (typeof window === 'undefined') return false;
  if ('wakeLock' in navigator) {
    const wakeLock = localStorage.getItem('rfs:wakeLock');
    if (!['true', 'false'].includes(wakeLock)) {
      localStorage.setItem('rfs:wakeLock', true);
      return true;
    }
    return wakeLock === 'true';
  }
  localStorage.removeItem('rfs:wakeLock');
  return null;
};

const getZoomValue = () => {
  if (typeof window === 'undefined') return 1;
  try {
    const zoom = parseFloat(localStorage.getItem('rfs:zoom'));
    if (zoom < 0.5 || zoom > 3 || Number.isNaN(zoom)) throw new Error();
    return zoom;
  } catch (e) {
    localStorage.setItem('rfs:zoom', 1);
    return 1;
  }
};

const getSwapButtonsValue = () => {
  if (typeof window === 'undefined') return false;
  try {
    const swapButtons = localStorage.getItem('rfs:swapButtons');
    if (!['true', 'false'].includes(swapButtons)) throw new Error();
    return swapButtons === 'true';
  } catch (e) {
    localStorage.setItem('rfs:swapButtons', false);
    return false;
  }
};

export default {
  code: getCodeValue(),
  vibrate: getVibrateValue(),
  wakeLock: getWakeLockValue(),
  zoom: getZoomValue(),
  swapButtons: getSwapButtonsValue(),
};
